// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"importLoaders":1}!./~/vue-loader/lib/style-rewriter.js?{"id":"data-v-24a70e5e","scoped":false,"hasInlineConfig":false}!./~/postcss-loader!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=2!./components/LumiNavbar.vue
// module id = 41
// module chunks = 0